import { defineInlineEdit } from "../../../../../components/MobileList/inlineEdit";

/** views/management/groups/from submits the whole form, which is just `name`. */
export default defineInlineEdit({
  api: "group",
  permission: "group_edit",
  hydrate: false,
  toPayload: (source) => ({ name: source.name ?? "" }),
  fields: {
    name: { label: "الاسم", type: "text", required: true },
  },
});
